module.exports = __webpack_public_path__ + "img/user-login-illustration.75bc63ec.png";